import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'router-outlet',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RouterOutletStubComponent { }
